// share.js
import React, { useState } from "react";

const Share = () => {
  const [showCopied, setShowCopied] = useState(false);
  const handleCopyLink = () => {
    const link = "https://hotelcondesa.qrshare.app/";
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy link: ", err);
      });
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        onClick={handleCopyLink}
        style={{
          borderRadius: "8px",
          padding: "12px",
          backgroundColor: "#f8f9fa",
          border: "1px solid #ced4da",
        }}
      >
        <i className="bi bi-share" />
      </button>
      {showCopied && (
        <div
          style={{
            position: "absolute",
            top: "calc(80% + 2px)",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            width: "120px",
            whiteSpace: "nowrap",
            color: "var(--font-description-color)",
            fontSize: "12px",
            backgroundColor: "#192733",
            borderRadius: "10px",
            padding: "6px 16px",
          }}
        >
          ¡Enlace copiado!
        </div>
      )}
    </div>
  );
};

export default Share;
